import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyA0hgmZ5CLaD4qqShhPXCgNcZL3bQBONXY",
  authDomain: "doctor-portal-5.firebaseapp.com",
  projectId: "doctor-portal-5",
  storageBucket: "doctor-portal-5.appspot.com",
  messagingSenderId: "332492077949",
  appId: "1:332492077949:web:21ca9f9b4fd8e59010ea14",
};

const app = initializeApp(firebaseConfig);

export default app;
